<!-- 
// +----------------------------------------------------------------------
// | LightPicture [ 图床 ]
// +----------------------------------------------------------------------
// | 企业团队图片资源管理系统
// +----------------------------------------------------------------------
// | Github: https://github.com/osuuu/LightPicture
// +----------------------------------------------------------------------
// | Copyright © http://picture.h234.cn All rights reserved.
// +----------------------------------------------------------------------
// | Author: Team <admin@osuu.net>
// +---------------------------------------------------------------------- 
-->
<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">系统设置</div>
          <div class="card-body">
            <div class="demo-spin-container" v-if="loading">
              <Spin fix size="large"></Spin>
            </div>
            <Tabs type="card" :animated="false" v-else>
              <TabPane label="基础配置">
                <Form :label-width="140">
                  <FormItem v-for="item in basicsList" :key="item.id" :label="item.title">
                    <i-switch v-if="item.attr == 'switch'" v-model="item.value" true-value="1" false-value="0" />
                    <InputNumber v-if="item.attr == 'number'" v-model="item.value" :min="0" style="width: 70%">
                    </InputNumber>
                    <Input v-if="item.attr == 'input'" v-model="item.value" :placeholder="item.title"></Input>
                    <RadioGroup v-if="item.attr == 'radio'" v-model="item.value">
                      <Radio v-for="(items, ind) in item.extend" :key="ind" :label="items">{{ items }}</Radio>
                    </RadioGroup>
                    <p style="font-size:12px;color:#999" v-if="item.des">
                      * {{item.des}}
                    </p>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="Save(basicsList,true)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="公告管理">
                <Form :label-width="120">
                  <FormItem label="公告内容">
                    <AnnounceEditor v-model="announceContent"></AnnounceEditor>
                    <p style="font-size:12px;color:#999;margin-top:8px">* 公告将在用户首页顶部展示，内容为空则不显示；编辑器内图片走系统上传接口</p>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="saveAnnounce" :loading="creating3">保存公告</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="邮箱配置">
                <Form :label-width="120">
                  <FormItem v-for="item in emailList" :key="item.id" :label="item.title">
                    <Input v-if="item.attr == 'input' && item.key == 'email_pwd'" v-model="item.value" password
                      :placeholder="item.title"></Input>
                    <Input v-else-if="item.attr == 'input'" v-model="item.value" :placeholder="item.title"></Input>
                    <RadioGroup v-if="item.attr == 'radio'" v-model="item.value">
                      <Radio v-for="(items, ind) in item.extend" :key="ind" :label="items">{{ items }}</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem label="邮件模板">
                    <Input v-model="emailTemplateContent" type="textarea" :rows="12"
                      placeholder="邮件 HTML 模板，占位符：[标题] [内容] [网站名称] [网站地址]"></Input>
                    <p style="font-size:12px;color:#999">
                      * HTML 模板，占位符：[标题]=邮件主题、[内容]=正文、[网站名称]=系统名称、[网站地址]=站点地址；验证码 / 重置密码等邮件均使用此模板
                    </p>
                    <Button size="small" @click="resetTemplate" style="margin-top:8px">恢复默认模板</Button>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="Save(emailList)" :loading="creating">保存</Button>
                    <Button type="warning" @click="sendTest" :loading="creating2">发送测试邮件</Button>
                    <p style="font-size:12px;color:#999">* 发送测试邮件会发送至当前登录用户的邮箱，请确保当前登录用户的账号为邮箱格式</p>
                  </FormItem>
                </Form>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getSetup,
    putSetup,
    postSendMail,
    getIndex
  } from "@/api";
  import {
    mapMutations
  } from "vuex";
  import AnnounceEditor from "@/components/AnnounceEditor.vue";
  export default {
    components: {
      AnnounceEditor
    },
    data() {
      return {
        emailList: [],
        basicsList: [],
        emailTemplateId: "",
        emailTemplateContent: "",
        defaultTemplate: '<html lang="zh"><head><meta http-equiv="Content-Type" content="text/html;charset=utf-8"/></head><body><div style="box-sizing:border-box;text-align:center;min-width:320px;max-width:660px;margin:auto;padding:20px 0 30px;"><div style="background-color:#fff;padding:23px 0 20px;box-shadow:0 1px 1px 0 rgba(0,0,0,0.1);text-align:left;border:1px solid #f0f0f0;"><div style="padding:0 24px;"><h1 style="font-weight:bold;font-size:20px;line-height:36px;margin:0 0 16px;color:#333;">[标题]</h1><p style="font-size:14px;color:#333;line-height:24px;margin:0 0 24px;word-break:break-all;">[内容]</p></div><p style="font-size:12px;color:#999;padding:0 24px;">本邮件由 [网站名称] 系统发送（[网站地址]），请勿直接回复。</p></div></div></body></html>',
        sms: {},
        creating: false,
        creating2: false,
        creating3: false,
        loading: true
      };
    },
    created() {
      this._getData();
      this._getAnnounce();
      this._getEmailTemplate();
    },

    methods: {
      ...mapMutations(["addConfig"]),
      // 获取邮件模板（数据库有值用数据库的，否则填充预设模板）
      _getEmailTemplate() {
        getSetup("email_template").then((res) => {
          if (res.data.length > 0) {
            this.emailTemplateId = res.data[0].id;
            this.emailTemplateContent = res.data[0].value || this.defaultTemplate;
          } else {
            this.emailTemplateContent = this.defaultTemplate;
          }
        });
      },
      // 恢复默认模板（填充后需点保存）
      resetTemplate() {
        this.emailTemplateContent = this.defaultTemplate;
        this.$Message.success({
          background: true,
          content: "已填充默认模板，点击保存生效",
        });
      },
      // 获取公告
      _getAnnounce() {
        getSetup("announce").then((res) => {
          if (res.data.length > 0) {
            this.announceId = res.data[0].id;
            this.announceContent = res.data[0].value;
          }
        });
      },
      // 保存公告
      saveAnnounce() {
        if (!this.announceId) {
          this.$Message.error({
            background: true,
            content: "公告配置不存在，请检查数据库",
          });
          return;
        }
        this.creating3 = true;
        putSetup({
          createData: [{
            id: this.announceId,
            value: this.announceContent,
          }],
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: "公告已保存",
            });
            getIndex().then((indexRes) => {
              this.addConfig(indexRes.data);
            });
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.creating3 = false;
        });
      },
      // 获取列表
      _getData() {
        getSetup("basics").then((res) => {
          this.basicsList = res.data;
          this.loading = false
        });
        getSetup("email").then((res) => {
          this.emailList = res.data;
          this.loading = false
        });
      },
      // 基础配置 / 邮箱配置（邮箱配置会连同邮件模板一起保存）
      Save(arr, reload) {
        const createData = arr.map((item) => ({ id: item.id, value: item.value }));
        if (arr === this.emailList && this.emailTemplateId) {
          createData.push({ id: this.emailTemplateId, value: this.emailTemplateContent });
        }
        this.creating = true;
        putSetup({
          createData,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();

            if (reload == true) {
              getIndex().then((res) => {
                this.addConfig(res.data)
                location.reload();
              });
            }

          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.creating = false;
        });
      },
      // 测试邮件
      sendTest() {
        this.$Modal.confirm({
          title: "发送测试邮件",
          content: "请确保当前设置已配置完毕且已保存，当前登录用户邮箱是否能接收邮件，是否发送测试？",
          onOk: () => {
            this.creating2 = true
            postSendMail().then(res => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
              this.creating2 = false
            })
          },
        });

      }
    },
  };
</script>

<style lang="less" scoped>
  .card-body {
    min-height: 435px;
  }

  .ivu-radio-wrapper {
    margin-right: 20px;
  }

  .ivu-btn {
    margin-right: 10px;
  }
</style>